import { useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs, { Dayjs } from "dayjs";
import { SubHeaderBase } from "@/components/molecules/SubHeader";
import { useGetCollections } from "@/services/LogisticsCoordinator";
import shared from "../styles.module.css";
import { startOfWeek, SubHeaderTitle } from "../shared";
import ScheduleBoard, { Filter } from "./ScheduleBoard";
import ScheduledDetail from "./ScheduledDetail";

type SortBy = "site" | "driver";

const Scheduled = () => {
  const { t } = useTranslation();
  const [weekStart, setWeekStart] = useState<Dayjs>(() => startOfWeek(dayjs()));
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [filter, setFilter] = useState<Filter>("all");
  const [sortBy, setSortBy] = useState<SortBy>("site");

  const from = weekStart.startOf("day").toISOString();
  const to = weekStart.add(6, "day").endOf("day").toISOString();
  const { data: collectionData, isFetching } = useGetCollections(from, to);

  const collections = collectionData?.collections ?? [];
  const selected = collections.find((c) => c.id === selectedId) ?? collections[0];

  const statusCounts: Record<Filter, number> = {
    all: collectionData?.total ?? 0,
    SCHEDULED: collectionData?.scheduledCount ?? 0,
    IN_PROGRESS: collectionData?.inProgressCount ?? 0,
    COMPLETED: collectionData?.completedCount ?? 0,
  };

  const visible = filter === "all" ? collections : collections.filter((c) => c.status === filter);

  return (
    <div className={shared.page}>
      <SubHeaderBase variant="secondary">
        <SubHeaderTitle
          heading={t("containers:scheduled.title")}
          sub={t("containers:scheduled.subtitle", { count: collections.length })}
        />
      </SubHeaderBase>

      <main className={shared.layout}>
        <ScheduleBoard
          collections={visible}
          selectedId={selected?.id ?? null}
          sortBy={sortBy}
          onSortChange={setSortBy}
          onSelect={setSelectedId}
          filter={filter}
          onFilterChange={setFilter}
          counts={statusCounts}
          weekStart={weekStart}
          onWeekChange={setWeekStart}
          loading={isFetching}
        />

        {selected && <ScheduledDetail key={selected.id} collection={selected} />}
      </main>
    </div>
  );
};

export default Scheduled;
